import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-chart-pie",
  "use": "foquz-icon-chart-pie-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" id=\"foquz-icon-chart-pie\"><path d=\"M7 .062A8.003 8.003 0 00.025 7.366h2.008A6.003 6.003 0 017 2.083V.062zm2 2.021V.062a8.001 8.001 0 014.685 13.566l-1.27-1.566A6.002 6.002 0 009 2.082zm1.835 11.206a6.002 6.002 0 01-8.679-3.923H.116a8.002 8.002 0 0011.996 5.498l-1.277-1.575z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol